import { render, staticRenderFns } from "./RoutingMTK.vue?vue&type=template&id=190b13ba&scoped=true&"
import script from "./RoutingMTK.vue?vue&type=script&lang=js&"
export * from "./RoutingMTK.vue?vue&type=script&lang=js&"
import style0 from "./RoutingMTK.vue?vue&type=style&index=0&id=190b13ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b13ba",
  null
  
)

export default component.exports